import React, { useState } from "react";
import s from "./styles.module.scss";

const Input = ({
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  className = "",
  label,
  supportiveText,
  error,
  disabled = false,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  const getInputClass = () => {
    let classes = [s.customInput];

    if (isFocused) classes.push(s.customInput + "--focused");
    if (error) classes.push(s.customInput + "--error");
    if (disabled) classes.push(s.customInput + "--disabled");
    if (value?.length > 0) classes.push(s.customInput + "--filled");
    if (className) classes.push(className);

    return classes.join(" ");
  };

  const getSupportiveTextClass = () =>
    error
      ? `${s.supportiveText} ${s.supportiveText + "--error"}`
      : s.supportiveText;

  return (
    <div className={s.inputContainer}>
      {label && (
        <label className={s.inputLabel} htmlFor={name}>
          {label}
        </label>
      )}

      <div className={s.inputWrapper}>
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={getInputClass()}
          {...props}
        />
      </div>

      {(supportiveText || error) && (
        <div className={getSupportiveTextClass()}>
          {error || supportiveText}
        </div>
      )}
    </div>
  );
};

export default Input;
